import { makeMultiSearch, makeSearch } from "../../UI/Search/Search";
import CampaignService from "../../../Services/Campaign.service";
const makeSearchArgs = {
    loadOptions: (search, options) => 
    // @ts-expect-error not sure how to fix this -- the campaign type conflicts with itself.
    CampaignService.search({
        query: search,
        names: options.names,
        isDragAndDrop: options.isDragAndDrop,
        sendToInstitutionalEmail: options.sendToInstitutionalEmail,
        sendToPersonalEmail: options.sendToPersonalEmail,
        senderIds: options.senderIds,
        createdByIds: options.createdByIds,
        createdDateTo: options.createdDateTo,
        createdDateFrom: options.createdDateFrom,
        modifiedByIds: options.modifiedByIds,
        modifiedDateTo: options.modifiedDateTo,
        modifiedDateFrom: options.modifiedDateFrom,
        expirationDateTo: options.expirationDateTo,
        expirationDateFrom: options.expirationDateFrom,
        messageTemplateIds: options.messageTemplateIds,
        lastExecutionDateTo: options.lastExecutionDateTo,
        lastExecutionDateFrom: options.lastExecutionDateFrom,
        campaignTypeIds: options.campaignTypeIds,
        startedDateTo: options.startedDateTo,
        startedDateFrom: options.startedDateFrom,
        deletedDateTo: options.deletedDateTo,
        deletedDateFrom: options.deletedDateFrom,
        deletedByIds: options.deletedByIds,
        sendBehaviors: options.sendBehaviors,
        fromEmailAddressIds: options.fromEmailAddressIds,
        campaignContentTemplateIds: options.campaignContentTemplateIds,
        virtualizedAppName: options.virtualizedAppName,
        personTypeInternalName: options.personTypeInternalName,
        isStarted: options.isStarted,
        isStopped: options.isStopped,
    }, {
        sort: options.sort,
        order: options.order,
        max: options.max,
        offset: options.offset,
        // @ts-expect-error - TS2339 - Property 'lite' does not exist on type 'CampaignSearchArgs'.
        lite: options.lite,
    }).then(({ data }) => data),
    label: "name",
    value: "id",
};
export const CampaignSearch = makeSearch(makeSearchArgs);
export const CampaignMultiSearch = makeMultiSearch(makeSearchArgs);
